class VisitShowrooms {
  constructor() {
    this.showroomsContainer = document.querySelector('.showrooms-grid');
    this.scrollBar = document.querySelector('.showrooms-bar');
    this.showrooms = [];
    this.defaultOrder = ['OSBORNE PARK', 'CLAREMONT', 'JOONDALUP', 'COCKBURN', 'AUSTRALIND'];
    this.isDragging = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.init();
  }

  init() {
    if (!this.showroomsContainer) return;
    
    this.collectShowroomData();
    // Disabled: reordering logic - now using order from sections settings
    this.getLocationAndSort();
    this.initDragScroll();
    this.initScrollProgress();
  }

  collectShowroomData() {
    const cards = this.showroomsContainer.querySelectorAll('.showroom-card');
    
    cards.forEach(card => {
      const locationElement = card.querySelector('.showroom-card__location');
      const addressElement = card.querySelector('.showroom-card__address-text');
      
      if (!locationElement || !addressElement) return;
      
      const location = locationElement.textContent.trim();
      const addressText = addressElement.textContent.trim();
      const lat = parseFloat(card.dataset.lat);
      const lng = parseFloat(card.dataset.lng);
      
      if (isNaN(lat) || isNaN(lng)) return;
      
      this.showrooms.push({
        element: card,
        location: location,
        address: addressText,
        lat: lat,
        lng: lng
      });
    });
  }

  getLocationAndSort() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => this.sortByDistance(position.coords.latitude, position.coords.longitude),
        () => this.sortByDefault(),
        { timeout: 5000 }
      );
    } else {
      this.sortByDefault();
    }
  }

  sortByDistance(userLat, userLng) {
    const waCenter = { lat: -31.9505, lng: 115.8605 };
    const distanceToWA = this.calculateDistance(userLat, userLng, waCenter.lat, waCenter.lng);
    
    if (distanceToWA > 500) {
      this.sortByDefault();
      return;
    }

    this.showrooms.forEach(showroom => {
      showroom.distance = this.calculateDistance(userLat, userLng, showroom.lat, showroom.lng);
    });

    this.showrooms.sort((a, b) => a.distance - b.distance);
    this.reorderShowrooms();
  }

  sortByDefault() {
    this.showrooms.sort((a, b) => {
      const locationA = a.location.toUpperCase().replace(', WA', '').trim();
      const locationB = b.location.toUpperCase().replace(', WA', '').trim();
      
      const indexA = this.defaultOrder.indexOf(locationA);
      const indexB = this.defaultOrder.indexOf(locationB);
      
      if (indexA === -1 && indexB === -1) return 0;
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      
      return indexA - indexB;
    });

    this.reorderShowrooms();
  }

  reorderShowrooms() {
    this.showrooms.forEach(showroom => {
      this.showroomsContainer.appendChild(showroom.element);
    });
  }

  initDragScroll() {
    this.showroomsContainer.addEventListener('mousedown', (e) => {
      this.isDragging = true;
      this.startX = e.pageX - this.showroomsContainer.offsetLeft;
      this.scrollLeft = this.showroomsContainer.scrollLeft;
      this.showroomsContainer.style.cursor = 'grabbing';
      this.showroomsContainer.style.userSelect = 'none';
    });

    this.showroomsContainer.addEventListener('mouseleave', () => {
      this.isDragging = false;
      this.showroomsContainer.style.cursor = 'grab';
    });

    this.showroomsContainer.addEventListener('mouseup', () => {
      this.isDragging = false;
      this.showroomsContainer.style.cursor = 'grab';
    });

    this.showroomsContainer.addEventListener('mousemove', (e) => {
      if (!this.isDragging) return;
      e.preventDefault();
      const x = e.pageX - this.showroomsContainer.offsetLeft;
      const walk = (x - this.startX) * 2;
      this.showroomsContainer.scrollLeft = this.scrollLeft - walk;
    });
  }

  initScrollProgress() {
    if (!this.scrollBar) return;

    const updateScrollBar = () => {
      const scrollWidth = this.showroomsContainer.scrollWidth - this.showroomsContainer.clientWidth;
      const isScrollable = scrollWidth > 0;
      
      if (!isScrollable) {
        this.scrollBar.style.display = 'none';
        return;
      }
      
      this.scrollBar.style.display = 'block';
      const scrolled = this.showroomsContainer.scrollLeft;
      const scrollPercentage = (scrolled / scrollWidth) * 100;
      
      // Calculate max travel based on actual container and bar widths
      const barWrapper = this.scrollBar.parentElement;
      const containerWidth = barWrapper ? barWrapper.clientWidth : this.showroomsContainer.clientWidth;
      const barWidth = this.scrollBar.offsetWidth;
      const maxTravel = containerWidth - barWidth;
      
      const translateX = (maxTravel * scrollPercentage) / 100;
      
      this.scrollBar.style.transform = `translateX(${translateX}px)`;
    };

    this.showroomsContainer.addEventListener('scroll', updateScrollBar);
    window.addEventListener('resize', updateScrollBar);
    
    setTimeout(updateScrollBar, 100);
  }

  calculateDistance(lat1, lng1, lat2, lng2) {
    const R = 6371;
    const dLat = this.toRad(lat2 - lat1);
    const dLng = this.toRad(lng2 - lng1);
    
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(this.toRad(lat1)) * Math.cos(this.toRad(lat2)) *
              Math.sin(dLng / 2) * Math.sin(dLng / 2);
    
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  toRad(degrees) {
    return degrees * (Math.PI / 180);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new VisitShowrooms();
  });
} else {
  new VisitShowrooms();
}
